/**
 * Native mobile runtime hooks (Capacitor).
 * These calls are no-ops on the web / PWA — they only take effect
 * when the app runs inside the iOS/Android native shell.
 */
import { Capacitor } from "@capacitor/core";
import { StatusBar, Style } from "@capacitor/status-bar";
import { SplashScreen } from "@capacitor/splash-screen";
import { App } from "@capacitor/app";
import { Keyboard } from "@capacitor/keyboard";

export function initNativeShell() {
  if (!Capacitor.isNativePlatform()) return;

  // Status bar: dark text on our light body, blue on our dark headers.
  // We use Style.Light which means "content is light -> use light text" on a dark bg.
  StatusBar.setStyle({ style: Style.Light }).catch(() => {});
  StatusBar.setBackgroundColor({ color: "#0d3b66" }).catch(() => {});

  // Hide splash after 1st paint
  SplashScreen.hide({ fadeOutDuration: 400 }).catch(() => {});

  // Keyboard shouldn't overlap inputs on iOS
  Keyboard.setResizeMode({ mode: "body" }).catch(() => {});

  // Android hardware back button — respect browser history
  App.addListener("backButton", ({ canGoBack }) => {
    if (canGoBack) window.history.back();
    else App.exitApp();
  });
}
